// eslint-disable-next-line no-unused-vars
export default function preloaderPause (scene) {

	// TODO

    scene.load.image(`play`, `/img/generalSprites/play.png`);
    scene.load.image(`soundOn`, `/img/generalSprites/soundOn.png`);
    scene.load.image(`soundOff`, `/img/generalSprites/soundOff.png`);
    scene.load.image(`home`, `/img/generalSprites/home.png`);
    scene.load.image(`restart`, `/img/generalSprites/restart.png`);
    scene.load.image(`cancel`, `/img/generalSprites/cancel.png`);
    scene.load.image(`confirm`, `/img/generalSprites/confirm.png`);
    scene.load.image(`menu-pause`, `/img/menu-pause.png`);


}